import React, { useEffect, useMemo, useState } from "react";

import {
  Badge,
  Table,
  TableMetadata,
  Typography,
  useTable,
} from "@king-ict/eupisi-ui/components";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { getLocationProgramsByRequestId } from "../../../../api";
import { LocationProgramListItem } from "../../../../models";
import styles from "./RequestLocationProgramPage.module.scss";

export function LocationProgramDetails() {
  const { t } = useTranslation();

  const { requestId } = useParams<{ requestId: string }>();

  const [locationPrograms, setLocationPrograms] = useState(
    [] as LocationProgramListItem[]
  );

  useEffect(() => {
    (async () => {
      const res = await getLocationProgramsByRequestId(+requestId);
      setLocationPrograms(res);
    })();
  }, [requestId]);

  const locationProgramTableMetadata = useMemo(
    () =>
      ({
        rowKey: "id",
        columns: [
          {
            columnKey: "priorityColumn",
            accessor: (locationProgram) => {
              return (
                <>
                  <Badge
                    value={locationProgram.priority}
                    outline
                    color="grey"
                  />
                </>
              );
            },
          },
          {
            columnKey: "locationColumn",
            header: t("locationPrograms.location"),
            accessor: (locationProgram) => {
              return (
                <>
                  <Typography variant="baseBold">
                    {`${locationProgram.locationName}, ${locationProgram.townName}`}
                  </Typography>
                </>
              );
            },
          },
          {
            columnKey: "addressColumn",
            header: t("locationPrograms.address"),
            accessor: (locationProgram) => {
              return (
                <>
                  <Typography variant="base">
                    {locationProgram.address}
                  </Typography>
                </>
              );
            },
          },
          {
            columnKey: "programColumn",
            header: t("locationPrograms.program"),
            accessor: (locationProgram) => {
              return (
                <>
                  <Typography variant="base">
                    {locationProgram.programName}
                  </Typography>
                </>
              );
            },
          },
        ],
      } as TableMetadata<LocationProgramListItem>),
    [t]
  );

  const [tableProps, _, __] = useTable({
    metadata: locationProgramTableMetadata,
    data: locationPrograms,
    pagination: false,
    totalItems: locationPrograms.length,
  });

  return (
    <>
      <Typography
        component="h1"
        variant="largeBold"
        className={styles.rowHeadingSpace}
      >
        {t("locationPrograms.header")}
      </Typography>
      <Table {...tableProps} />
    </>
  );
}
